import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import { Link } from 'react-router-dom'
import { Header } from '../Common';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import ReactTooltip from 'react-tooltip'
import Affiliator from '../../Models/Affiliator';
class NewThisMonth extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            newusers: [],
        };
        this.getnewChildList();
    }
    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('info'))
        window.scrollTo(0, 0)
    }
    getnewChildList() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.newChildList(x.id).then(res => {
            console.log(res.data)
            this.setState({
                newusers: res.data.list
            })
            console.log(this.state.newusers)
        })
    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if(isMobile){
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid"  style={{minHeight: "600px"}}>
                        <div className="">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className=" mb-1 input_name big_font guide_text" style={{width:'100%', fontSize: "20px"}}>
                                        <strong>{this.props.t('1')}</strong>
                                    </div>
                                    <div>
                                        <table>
                                            <tbody style={{borderCollapse: "collapse"}}>
                                                {this.state.newusers.map(newu =>
                                                    <tr className="tr-bottom" style={{width: "100%"}}>
                                                        <td style={{width: "65%", borderBottom: "1px solid #ccd0c9", padding: "1%", fontSize: "12px"}}>{newu.first_name}</td>
                                                        <td style={{width: "35%", borderBottom: "1px solid #ccd0c9", fontSize: "12px"}}>{newu.created_at}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        } else {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text pages_headers" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                        </div>
                                        <div>
                                            <table style={{width: "100%"}}>
                                                <tbody>
                                                    {this.state.newusers.map(newu =>
                                                        <tr style={{width: "100%"}}>
                                                            <td style={{width: "65%", fontSize: "14px"}}>{newu.first_name}</td>
                                                            <td style={{width: "35%", fontSize: "14px"}}>{newu.created_at}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }

    }
}
export { NewThisMonth }


 NewThisMonth = withTranslation('src_Components_Affiliator_NewThisMonth')(NewThisMonth);